import type { BrandAssets } from '@mg/shared';
import { stableStringify } from './stableStringify';

/** What the Brand assets and style page edits and saves: colors, typography and logos. */
export type BrandAssetsStyle = Pick<BrandAssets, 'colors' | 'typography' | 'logos'>;

/**
 * The Brand assets and style page's save (PATCH /tenants/:id `{ brandAssets }`, web.md §6.3): colors,
 * typography and logos ONLY. Social hashtags and Catchphrases now live in the Brand information page's
 * Vocabulary (spec:185, :257), which saves them through the brand writer; sending this page's copy of
 * them could write back an older list over a newer one, so they are never in this body (E4). The
 * flag-on server also merges by key and ignores the two, so either side alone keeps them apart.
 */
export function assetsPayload(assets: BrandAssetsStyle): BrandAssetsStyle {
  return { colors: assets.colors, typography: assets.typography, logos: assets.logos };
}

/** Whether the page's colors, typography or logos differ from the saved ones, ignoring key order. */
export function assetsStyleChanged(current: BrandAssetsStyle, saved: BrandAssetsStyle): boolean {
  return stableStringify(assetsPayload(current)) !== stableStringify(assetsPayload(saved));
}
